<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="showSubmit" type="primary" size="small" :disabled="actionBusy" @click="submitApproval">提交审批</el-button>
            <el-button v-if="showWfApprove" type="primary" size="small" :disabled="actionBusy" @click="wfApprove">审批通过</el-button>
            <el-button v-if="showWfReject" type="primary" size="small" :disabled="actionBusy" @click="wfReject">驳回</el-button>
            <el-button v-if="showApprove" type="primary" size="small" :disabled="actionBusy" @click="approveHandle">审核</el-button>
            <el-button v-if="showUnapprove" type="primary" size="small" :disabled="actionBusy" @click="unapproveHandle">弃审</el-button>
            <el-button v-if="showTrail" type="primary" size="small" @click="trailVisible = true">审批轨迹</el-button>
            <el-button v-if="isAuth('sale:salesStockOut:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="enterEdit">修改</el-button>
            <el-button v-if="isAuth('sale:salesStockOut:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="deleteHandle">删除</el-button>
          </el-button-group>
          <div v-if="workflowActionHint" class="wf-hint">{{ workflowActionHint }}</div>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="90px" :disabled="formReadonly">
      <el-row>
        <el-col :span="6">
          <el-form-item label="出库单号" prop="stockOutCode">
            <el-input v-model="dataForm.stockOutCode" :readonly="codeReadonly || !!dataForm.stockOutId" :placeholder="codeReadonly ? '保存时自动生成' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="出库日期" prop="stockOutDate">
            <el-date-picker v-model="dataForm.stockOutDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="shippingNoticeRequired" label="发货通知" prop="shippingNoticeId">
            <el-select v-model="dataForm.shippingNoticeId" filterable :clearable="false" placeholder="选择已审核发货通知" style="width:100%" @change="onShippingNoticeChange">
              <el-option v-for="item in shippingNoticeOptions" :key="item.noticeId" :label="item.noticeCode + ' / ' + item.salesOrderCode + ' / ' + item.customerName" :value="item.noticeId" />
            </el-select>
          </el-form-item>
          <el-form-item v-else label="销售订单" prop="salesOrderId">
            <el-select v-model="dataForm.salesOrderId" filterable :clearable="false" placeholder="选择已确认订单" style="width:100%" @change="onSalesOrderChange">
              <el-option v-for="item in salesOrderOptions" :key="item.salesOrderId" :label="item.salesOrderCode + ' / ' + item.customerName" :value="item.salesOrderId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="!shippingNoticeRequired" :span="4">
          <el-form-item label="客户"><span>{{ dataForm.customerName || '—' }}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="shippingNoticeRequired">
        <el-col :span="6"><el-form-item label="销售单号"><span>{{ dataForm.salesOrderCode || '—' }}</span></el-form-item></el-col>
        <el-col :span="6"><el-form-item label="客户"><span>{{ dataForm.customerName || '—' }}</span></el-form-item></el-col>
      </el-row>
      <el-form-item label="备注"><el-input v-model="dataForm.remark" /></el-form-item>
      <el-table border :data="dataForm.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="130" header-align="center" align="left" />
        <el-table-column prop="materialName" label="产品名称" min-width="130" header-align="center" align="left" />
        <el-table-column prop="specs" label="规格" min-width="100" header-align="center" align="left" />
        <el-table-column prop="remainQuantity" label="可出库" width="90" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.remainQuantity) }}</template>
        </el-table-column>
        <el-table-column v-if="hasProductionCap" prop="productionReceivedQty" label="已完工" width="80" header-align="center" align="left">
          <template slot-scope="scope">{{ formatQty(scope.row.productionReceivedQty) }}</template>
        </el-table-column>
        <el-table-column prop="quantity" label="出库数量" width="180" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="formReadonly ? Math.max(Number(scope.row.remainQuantity || 0), Number(scope.row.quantity || 0)) : Number(scope.row.remainQuantity || 0)" :precision="2" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column prop="wareHouseId" label="出库库位" min-width="220" header-align="center" align="left">
          <template slot="header">
            <span>出库库位</span>
            <el-tooltip v-if="outboundFifoEnabled && !formReadonly" content="已启用先进先出，审核后由系统自动分配库位" placement="top">
              <i class="el-icon-info" style="margin-left:4px;color:#909399;" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <warehouse-location-select v-model="scope.row.wareHouseId" :disabled="isOutboundWarehouseSelectDisabled()" />
          </template>
        </el-table-column>
        <el-table-column prop="allocationText" label="系统分配" min-width="180" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column v-if="!formReadonly" prop="usableQuantity" label="可用库存" width="90" header-align="center" align="left">
          <template slot-scope="scope">
            <span :class="{ 'sales-stock-out-qty-warn': isLineUsableInsufficient(scope.row) }">{{ formatQty(scope.row.usableQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="dataForm.lines.splice(scope.$index, 1)">删除</el-button></template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formReadonly" type="primary" :disabled="submitLoading" @click="submitHandle">确定</el-button>
    </span>
    <workflow-trail-dialog :visible.sync="trailVisible" :workflow-instance="dataForm.workflowInstance" :tasks="trailTasks" />
  </el-dialog>
</template>

<script>
import WorkflowTrailDialog from '../../components/WorkflowTrailDialog.vue'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import request from '../../api/request'
import { docAction, docGet, docInfo, docSave } from '../../api/erp/doc'
import { fetchPerms } from '../../api/auth'
import inventoryOutboundFifoMixin from '../../mixins/inventory-outbound-fifo'
import { canShowDirectApproveButton, isWorkflowEditable, normalizeWorkflowDocUi, shouldShowWorkflowTrail } from '../../utils/workflow'

function today() {
  const d = new Date()
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function blankForm(id) {
  return {
    stockOutId: id || '', stockOutCode: '', stockOutDate: today(), salesOrderId: '', salesOrderCode: '',
    shippingNoticeId: '', customerId: '', customerName: '', approveStatus: '0', workflowStatus: 'draft',
    workflowInstance: null, myPendingTask: null, workflowDocUi: null, remark: '', lines: []
  }
}

export default {
  components: { WorkflowTrailDialog, WarehouseLocationSelect },
  mixins: [inventoryOutboundFifoMixin],
  data() {
    return {
      visible: false, readonly: false, submitLoading: false, actionBusy: false, codeReadonly: false,
      workflowDocUiReady: false, trailVisible: false, shippingNoticeRequired: false,
      salesOrderOptions: [], shippingNoticeOptions: [], permCodes: [], dataForm: blankForm(),
      reservedQuantityByMaterial: {},
      dataRule: {
        stockOutCode: [{ required: true, message: '出库单号不能为空', trigger: 'blur' }],
        stockOutDate: [{ required: true, message: '出库日期不能为空', trigger: 'change' }],
        salesOrderId: [{ required: true, message: '请选择销售订单', trigger: 'change' }],
        shippingNoticeId: [{ required: true, message: '请选择发货通知', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly || this.dataForm.approveStatus === '2' || !this.canEditDoc },
    formRules() {
      if (this.formReadonly) return {}
      const rules = this.shippingNoticeRequired
        ? { stockOutDate: this.dataRule.stockOutDate, shippingNoticeId: this.dataRule.shippingNoticeId }
        : { stockOutDate: this.dataRule.stockOutDate, salesOrderId: this.dataRule.salesOrderId }
      if (!this.codeReadonly) rules.stockOutCode = this.dataRule.stockOutCode
      return rules
    },
    dialogTitle() {
      if (this.readonly) return '查看销售出库'
      return this.dataForm.stockOutId ? '修改销售出库' : '新增销售出库'
    },
    hasProductionCap() {
      return (this.dataForm.lines || []).some(line => Number(line.productionAllocatedQty || 0) > 0 || Number(line.productionReceivedQty || 0) > 0)
    },
    showViewToolbar() { return this.readonly && !!this.dataForm.stockOutId },
    workflowUi() { return normalizeWorkflowDocUi(this.dataForm.workflowDocUi) },
    canEditDoc() { return isWorkflowEditable(this.dataForm.workflowStatus, this.dataForm.approveStatus) },
    allowSaveDirectApprove() {
      const ui = this.workflowUi
      return !!(ui && ui.workflowEnabled && !ui.definitionMatched && ui.directApproveAllowed)
    },
    showApprove() {
      if (!this.showViewToolbar || !this.workflowDocUiReady || String(this.dataForm.approveStatus) === '2') return false
      if (!canShowDirectApproveButton(this.dataForm.workflowDocUi)) return false
      if (this.isAuth('sale:salesStockOut:approve')) return true
      return this.allowSaveDirectApprove && (this.isAuth('sale:salesStockOut:save') || this.isAuth('sale:salesStockOut:update'))
    },
    showUnapprove() { return this.showViewToolbar && this.isAuth('sale:salesStockOut:unapprove') && String(this.dataForm.approveStatus) === '2' },
    showSubmit() {
      const ui = this.workflowUi
      if (!this.showViewToolbar || !this.workflowDocUiReady || !ui || !ui.submitAllowed) return false
      const uid = (this.$store.state.user || {}).id
      if (this.dataForm.createBy && uid && String(this.dataForm.createBy) !== String(uid)) return false
      return this.isAuth('sale:salesStockOut:submit') || this.isAuth('sale:salesStockOut:save') || this.isAuth('sale:salesStockOut:update')
    },
    showWfApprove() {
      const task = this.dataForm.myPendingTask
      return this.showViewToolbar && this.isAuth('workflow:task:approve') && task && task.taskId
    },
    showWfReject() { return this.showWfApprove && this.isAuth('workflow:task:reject') },
    showTrail() {
      return shouldShowWorkflowTrail({
        inViewMode: this.showViewToolbar, workflowInstance: this.dataForm.workflowInstance,
        workflowDocUi: this.workflowUi, workflowDocUiReady: this.workflowDocUiReady
      })
    },
    trailTasks() {
      const inst = this.dataForm.workflowInstance
      return (inst && inst.tasks) || []
    },
    workflowActionHint() {
      const ui = this.workflowUi
      if (!ui || !ui.workflowEnabled || String(this.dataForm.approveStatus) === '2') return ''
      if (ui.inApproval) {
        const uid = (this.$store.state.user || {}).id
        const inst = this.dataForm.workflowInstance
        if (!(this.dataForm.myPendingTask && this.dataForm.myPendingTask.taskId) && inst && uid && String(inst.submitBy) === String(uid)) {
          return '当前步骤需由其他审批人处理（不允许提交人自审），请等待待办人审批。'
        }
        return ''
      }
      if (!ui.definitionMatched && ui.submitAllowed) return '已启用多级审批，尚未配置审批流程。请点击「提交审批」查看配置指引。'
      if (!ui.definitionMatched && ui.directApproveAllowed) return '已启用多级审批，尚未配置匹配的审批流程，可直接审核或联系管理员配置流程。'
      if (!ui.definitionMatched && !ui.directApproveAllowed && !ui.submitAllowed) return '已启用多级审批，请先在「审批流程定义」中配置销售出库流程后再提交。'
      return ''
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    enterEdit() {
      this.readonly = false
      this.refreshLinesUsableQty()
    },
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.reservedQuantityByMaterial = {}
      this.visible = true
      this.submitLoading = false
      this.actionBusy = false
      this.codeReadonly = false
      this.workflowDocUiReady = false
      this.dataForm = blankForm(id)
      this.$nextTick(() => { if (this.$refs.dataForm) this.$refs.dataForm.clearValidate() })
      // 策略配置只影响库位选择；读取失败不能阻断已有单据的详情回显。
      Promise.all([this.loadOutboundFifoPolicy().catch(() => { this.outboundFifoEnabled = false }), docGet('/sale/salesStockOut/noticeRequired').then(res => { this.shippingNoticeRequired = res.data === true }).catch(() => { this.shippingNoticeRequired = false })]).then(() => {
        if (!id) this.resolveCode()
        if (id) {
          docInfo('/sale/salesStockOut', id).then(res => {
            const body = res.data || {}
            this.dataForm = {
              ...blankForm(id), ...body,
              stockOutDate: (body.stockOutDate || '').slice(0, 10),
              lines: (body.lines || []).map(line => ({ ...line, quantity: Number(line.quantity) }))
            }
            ;(body.lines || []).forEach(line => {
              if (!line.materialId) return
              this.reservedQuantityByMaterial[line.materialId] =
                (this.reservedQuantityByMaterial[line.materialId] || 0) + Number(line.quantity || 0)
            })
            this.workflowDocUiReady = !!normalizeWorkflowDocUi(this.dataForm.workflowDocUi)
            this.clearOutboundLineWarehouses(this.dataForm.lines)
            if (this.shippingNoticeRequired) this.loadShippingNoticeOptions(body.shippingNoticeId)
            else this.loadSalesOrderOptions(body.salesOrderId)
            if (!this.formReadonly) this.refreshLinesUsableQty()
          }).catch(() => { this.$message.error('销售出库单详情加载失败，请稍后重试') })
        } else if (this.shippingNoticeRequired) this.loadShippingNoticeOptions()
        else this.loadSalesOrderOptions()
      })
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'salesStockOut' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.dataForm.stockOutCode = data.previewCode
        this.$nextTick(() => {
          if (this.$refs.dataForm) this.$refs.dataForm.clearValidate('stockOutCode')
        })
      }).catch(() => {})
    },
    loadSalesOrderOptions(includeSalesOrderId) {
      docGet('/sale/salesStockOut/ordersForStockOut', {
        includeSalesOrderId: includeSalesOrderId || '',
        excludeStockOutId: this.dataForm.stockOutId || ''
      }).then(res => { this.salesOrderOptions = res.data || [] }).catch(() => {})
    },
    loadShippingNoticeOptions(includeNoticeId) {
      docGet('/sale/salesStockOut/noticesForStockOut', { includeNoticeId: includeNoticeId || '', excludeStockOutId: this.dataForm.stockOutId || '' }).then(res => {
        this.shippingNoticeOptions = res.data || []
      }).catch(() => {})
    },
    onSalesOrderChange(salesOrderId) {
      this.dataForm.lines = []
      const hit = this.salesOrderOptions.find(item => item.salesOrderId === salesOrderId)
      if (!salesOrderId || !hit) {
        this.dataForm.salesOrderCode = ''
        this.dataForm.customerId = ''
        this.dataForm.customerName = ''
        return
      }
      this.dataForm.salesOrderCode = hit.salesOrderCode
      this.dataForm.customerId = hit.customerId
      this.dataForm.customerName = hit.customerName
      if (!this.formReadonly) this.applyOrderLines(salesOrderId)
    },
    applyOrderLines(salesOrderId) {
      docGet('/sale/salesStockOut/linesForOrder', { salesOrderId: salesOrderId || this.dataForm.salesOrderId, excludeStockOutId: this.dataForm.stockOutId || '' }).then(res => {
        const lines = res.data || []
        if (!lines.length) { this.$message.warning('该订单没有可出库明细'); return }
        this.dataForm.lines = lines.map(line => ({
          salesOrderLineId: line.salesOrderLineId, materialId: line.materialId, materialCode: line.materialCode,
          materialName: line.materialName, specs: line.specs, remainQuantity: Number(line.remainQuantity || 0),
          productionAllocatedQty: Number(line.productionAllocatedQty || 0), productionReceivedQty: Number(line.productionReceivedQty || 0),
          quantity: Number(line.remainQuantity || 0), wareHouseId: ''
        }))
        this.clearOutboundLineWarehouses(this.dataForm.lines)
        this.refreshLinesUsableQty()
      }).catch(() => {})
    },
    onShippingNoticeChange(noticeId) {
      this.dataForm.lines = []
      const notice = this.shippingNoticeOptions.find(item => item.noticeId === noticeId)
      if (!noticeId || !notice) {
        this.dataForm.salesOrderId = ''
        this.dataForm.salesOrderCode = ''
        this.dataForm.customerId = ''
        this.dataForm.customerName = ''
        return
      }
      this.dataForm.salesOrderId = notice.salesOrderId
      this.dataForm.salesOrderCode = notice.salesOrderCode
      this.dataForm.customerId = notice.customerId
      this.dataForm.customerName = notice.customerName
      if (!this.formReadonly) this.applyNoticeLines(noticeId)
    },
    applyNoticeLines(noticeId) {
      docGet('/sale/salesStockOut/linesForNotice', { noticeId: noticeId || this.dataForm.shippingNoticeId, excludeStockOutId: this.dataForm.stockOutId || '' }).then(res => {
        const lines = res.data || []
        if (!lines.length) { this.$message.warning('该发货通知没有可出库明细'); return }
        this.dataForm.lines = lines.map(line => ({
          salesOrderLineId: line.salesOrderLineId, shippingNoticeLineId: line.noticeLineId, materialId: line.materialId,
          materialCode: line.materialCode, materialName: line.materialName, specs: line.specs,
          remainQuantity: Number(line.remainQuantity || 0), quantity: Number(line.remainQuantity || 0), wareHouseId: ''
        }))
        this.clearOutboundLineWarehouses(this.dataForm.lines)
        this.refreshLinesUsableQty()
      }).catch(() => {})
    },
    formatQty(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (Number.isNaN(n)) return '-'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    isLineUsableInsufficient(line) {
      if (!line || line.usableQuantity == null || line.usableQuantity === '') return false
      const need = Number(line.quantity || 0)
      const usable = Number(line.usableQuantity)
      return need > 0 && !Number.isNaN(usable) && need > usable
    },
    refreshLinesUsableQty() {
      const lines = (this.dataForm.lines || []).filter(line => line && line.materialId)
      const materialIds = [...new Set(lines.map(line => line.materialId))]
      if (!materialIds.length) return
      request.post('/inventory/quantity/usableSums', { materialIds }).then(res => {
        const sums = res.data || {}
        lines.forEach(line => this.$set(line, 'usableQuantity',
          Number(sums[line.materialId] || 0) + Number(this.reservedQuantityByMaterial[line.materialId] || 0)))
      }).catch(() => {})
    },
    submitHandle() {
      if (!this.dataForm.lines.length) { this.$message.error('请至少维护一条出库明细'); return }
      if (this.shippingNoticeRequired && this.dataForm.lines.find(line => !line.shippingNoticeLineId)) { this.$message.error('出库明细须来自发货通知'); return }
      if (this.dataForm.lines.find(line => !line.salesOrderLineId)) { this.$message.error('出库明细须来自销售订单'); return }
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        docSave('/sale/salesStockOut', this.dataForm, 'stockOutId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.submitLoading = false })
      })
    },
    reload() { if (this.dataForm.stockOutId) this.init(this.dataForm.stockOutId, true) },
    approveHandle() {
      this.$confirm('审核后将扣减库存并更新订单已出库数量，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockOut', 'approve', { stockOutId: this.dataForm.stockOutId }).then(() => {
          this.$message.success('审核成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    unapproveHandle() {
      this.$confirm('弃审将恢复库存与订单已出库数量，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockOut', 'unapprove', { stockOutId: this.dataForm.stockOutId }).then(() => {
          this.$message.success('弃审成功'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    deleteHandle() {
      this.$confirm('确定删除该出库单?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        docAction('/sale/salesStockOut', 'delete', { stockOutId: this.dataForm.stockOutId }).then(() => {
          this.$message.success('删除成功'); this.visible = false; this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    submitApproval() {
      const ui = this.workflowUi
      if (ui && ui.workflowEnabled && !ui.definitionMatched) {
        this.$alert('尚未配置销售出库审批流程，请先在「审批流程定义」中新增并启用流程（至少一个审批步骤）后再提交。', '未配置审批流程', { type: 'warning', confirmButtonText: '我知道了' })
        return
      }
      this.$confirm('提交后将进入审批流程，期间不可修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/workflow/submit', { bizType: 'salesStockOut', bizId: this.dataForm.stockOutId }).then(() => {
          this.$message.success('提交成功'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfApprove() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('审批意见（可选）', '审批通过', { inputType: 'textarea', confirmButtonText: '通过' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/approve', { taskId: task.taskId, comment: value || '' }).then(() => {
          this.$message.success('审批通过'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    wfReject() {
      const task = this.dataForm.myPendingTask
      if (!task || !task.taskId) return
      this.$prompt('请输入驳回原因', '审批驳回', { inputType: 'textarea', confirmButtonText: '驳回', inputValidator: v => !!(v && String(v).trim()) || '驳回原因不能为空' }).then(({ value }) => {
        this.actionBusy = true
        request.post('/workflow/task/reject', { taskId: task.taskId, comment: String(value).trim() }).then(() => {
          this.$message.success('已驳回'); this.$emit('refreshDataList'); this.reload()
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.doc-dialog-actions { display: flex; flex-direction: column; align-items: flex-end; }
.doc-dialog-actions >>> .el-button-group { display: flex; flex-wrap: wrap; }
.wf-hint { margin-top: 6px; color: #e6a23c; font-size: 12px; line-height: 1.4; }
.sales-stock-out-qty-warn { color: #e6a23c; font-weight: 600; }
</style>
